<template>
  <span>
    <span class="screenplay-shadow"></span>
    <span
      class="screenplay-holder"
      :class="[numberId ? 'stl-lt-box' : 'stl-lb-box']"
    >
      <span class="screenplay-holder-info">
        <span class="screenplay-holder__header">
          <span class="screenplay-holder__title"> </span>
          <a @click="closeSecondTutorial" class="screenplay-holder__close" />
        </span>
        <!-- screenplay-holder__header -->
        <span
          v-if="numberId && project.UF_HELP && project.UF_HELP.SCENARIO && project.UF_HELP.SCENARIO.STEP2 && project.UF_HELP.SCENARIO.STEP2[step]"
          class="screenplay-holder__content text-center"
          v-html="project.UF_HELP.SCENARIO.STEP2[step][numberId]"
        />
        <span
          v-else-if="project.UF_HELP && project.UF_HELP.SCENARIO && project.UF_HELP.SCENARIO.STEP2 && project.UF_HELP.SCENARIO.STEP2[step]"
          class="screenplay-holder__content text-center"
          v-html="project.UF_HELP.SCENARIO.STEP2[step]"
        />

        <!-- screenplay-holder__content -->
      </span>
      <!-- screenplay-holder-info -->
      <span class="screenplay-holder__footer">
        <span class="screenplay-holder__etap">
          шаг
          {{ project.ARR2.indexOf(stepName) + 1 }}
          из
          {{ project.ARR2.length }}
        </span>
        <span class="screenplay-holder__butt-area">
          <a
            v-if="project.ARR2.indexOf(stepName) > 0"
            @click="nextStepSecondTutorial($event, stepName, 'decrement')"
            class="screenplay-holder__butt screenplay-holder__butt-prev"
          >
            Шаг назад
          </a>
          <span v-else></span>
          <a
            @click="nextStepSecondTutorial($event, stepName, 'increment')"
            class="screenplay-holder__butt screenplay-holder__butt-next"
          >
            {{
              project.ARR2.indexOf(stepName) + 1 !== project.ARR2.length
                ? "Далее"
                : "Завершить"
            }}
          </a>
        </span>
      </span>
    </span>
  </span>
</template>

<script>
export default {
  name: "SecondScenariosStep",
  props: ["project", "step", "stepName", "numberId"],

  methods: {
    nextStepSecondTutorial(event, step, operation) {
      event.stopImmediatePropagation();
      const operations = {
        decrement: "-1",
        increment: 1
      };
      this.project[step] = false;
      this.project[step] = false;
      const nextIndexStep =
        this.project.ARR2.indexOf(step) + Number(operations[operation]);
      if (nextIndexStep < this.project.ARR2.length) {
        this.project[this.project.ARR2[nextIndexStep]] = true;
        const el = this.$parent.$refs[this.project.ARR2[nextIndexStep]];
        // костыль для нормального скролла верхних элементов таблицы
        const topRefsElements = [
          "BUDGET_ZARPLATA",
          "BUDGET_WORKS",
          "BUDGET_MATERIALS",
          "BUDGET_OBORUDOVANIE",
          "BUDGET_ZAIM",
          "BUDGET_SOFINANCE"
        ];
        if (el && topRefsElements.includes(this.project.ARR2[nextIndexStep])) {
          window.scrollTo({ top: 0, behavior: "smooth" });
        } else if (el) {
          if (Array.isArray(el)) {
            el[0].scrollIntoView({
              behavior: "smooth",
              block: "center"
            });
          } else {
            el.scrollIntoView({
              behavior: "smooth",
              block: "center"
            });
          }
        }
      } else {
        this.closeSecondTutorial();
      }
    },
    closeSecondTutorial() {
      event.stopImmediatePropagation();
      const el = document.getElementsByClassName("area-shadow")[0];
      el.classList.remove("active");
      const footer = document.getElementsByClassName("footer")[0];
      footer.classList.remove("active");
      this.project.ARR2.forEach(el => {
        if (el in this.project) {
          this.project[el] = false;
        }
      });
    }
  }
};
</script>

<style scoped></style>
